import * as React from 'react';

interface ISectionHeaderProps {
    header: string;
    sectionLabel?: string;
    number?: string;
}

const SectionHeader: React.FC<ISectionHeaderProps> = ({ header, sectionLabel, number }) => {
    return (
        <React.Fragment>
            <div className='cip-business-sign-up__section-header'>
                {header && (
                    <h3>
                        {`${number}.`} {header}
                    </h3>
                )}
            </div>
            <div className='cip-business-sign-up__section-header__label'>{sectionLabel}</div>
        </React.Fragment>
    );
};

export default SectionHeader;
